import { Box, styled } from '@mui/material';

const StyledCommandChips = styled(Box)({
  display: 'flex',
  flexWrap: 'wrap',
  gap: 6,
});

export default StyledCommandChips;
